const footer = {
  "footer.cookie": "Cookie Settings",
  "footer.about": "ABOUT ACUVUE® DEFINE®",
  "footer.contact": "CONTACT US",
  "footer.policy": "PRIVACY POLICY",
  "footer.notice": "LEGAL NOTICE",
  "footer.legal": "<p>© Johnson & Johnson Vision 2023. All rights reserved. This site is published by Johnson & Johnson Vision, which is solely responsible for its content. It is intended for use by residents of Malaysia.</p> <p>ACUVUE® OASYS®, HydraLuxe™, MOIST®, DEFINE®, Natural Shine®, Radiant Bright™, Radiant Charm™, Radiant Sweet™, Radiant Chic™, LACREON®, HYDRACLEAR®, INTUISIGHT™, EYELID STABILIZED are trademarks of Johnson & Johnson Vision ©, Johnson & Johnson Pte. Ltd. 2023</p>",
}

export default footer
